import React, { useContext, useEffect, useState } from "react";
import { userContext } from "../Contexts/userContext";
import useFetch from "../Hooks/useFetch";
import useUpdate from "../Hooks/useUpdate";
import { dashboardURL } from "../Hooks/URL";
import Dashboard from "../Templates/Home/Dashboard/Dashboard";
import { Fetch } from "../Hooks/Fetch";

function DashboardPage() {
  const { contextData, setContextData } = useContext(userContext);

  const [dashboardData, setDashboard] = useState([]);
  const [settingsData, setSettingsData] = useState({});
  const [goUpdateSettings, setGoUpdateSettings] = useState(false);
  const [settingsUpdateData, setSettingsUpdateData] = useState({});

  const { data, loading, error } = useFetch(dashboardURL);
  const { state: updateState, loading: updateSettingsLoading } = useUpdate(
    dashboardURL,
    goUpdateSettings,
    setGoUpdateSettings,
    settingsUpdateData,
    null
  );

  useEffect(() => {
    if (!loading && !error && data) {
      // Check if data contains settings fields
      if (data.data?.registrationDeadLine !== undefined) {
        setSettingsData(data.data);
        // Extract dashboard data (remove settings fields)
        const {
          registrationDeadLine,
          editDeadLine,
          paymentDeadLine,
          registrationAbility,
          editAbility,
          paymentAbility,
          ...rest
        } = data.data;
        setDashboard(rest);
      } else {
        setDashboard(data.data);
      }
    }
  }, [data, loading, error]);

  // Refresh settings after update
  useEffect(() => {
    if (updateState.dataRes && !updateSettingsLoading) {
      Fetch(dashboardURL, {
        function: (data) => {
          if (data?.registrationDeadLine !== undefined) {
            setSettingsData(data);
            const {
              registrationDeadLine,
              editDeadLine,
              paymentDeadLine,
              registrationAbility,
              editAbility,
              paymentAbility,
              ...rest
            } = data;
            setDashboard(rest);
          }
        },
      });
    }
  }, [updateState, updateSettingsLoading]);

  useEffect(() => {
    setContextData({ ...contextData, page: "dashboard" });
  }, []);

  const handleUpdateSettings = (formData) => {
    setSettingsUpdateData(formData);
    setGoUpdateSettings(true);
  };

  return (
    <Dashboard
      contextData={contextData}
      dashboardData={dashboardData}
      settingsData={settingsData}
      onUpdateSettings={handleUpdateSettings}
      updateSettingsLoading={updateSettingsLoading || loading}
      updateState={updateState}
    />
  );
}

export default DashboardPage;
